import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import { IfFeatureService, NotificationsToast, NotificationsToastComponent } from '@tdwb/core';
import { Strategy } from '@tdwb/lazy/trading';
import { OrderNotificationsToast } from '../order-notifications-toast.domain';

/**
 * Order toast notifications toast component
 * Display order notification in notification conatiner
 */

@Component({
  selector: 'td-wb-order-notifications-toast',
  templateUrl: './order-notifications-toast.component.html',
  styleUrls: ['./order-notifications-toast.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class OrderNotificationsToastComponent implements NotificationsToastComponent {

  @Input() toast: OrderNotificationsToast;
  @Input() excessMessageCount: number;
  @Output() readonly onClose: EventEmitter<NotificationsToast> = new EventEmitter<NotificationsToast>();

  // eslint-disable-next-line @typescript-eslint/naming-convention
  readonly Strategy: typeof Strategy = Strategy;
  newMLONotificationEnabled: boolean;

  constructor(private featureService: IfFeatureService) {
    this.newMLONotificationEnabled = this.featureService.getFeatureFlag<boolean>('newMLONotification');
  }

  /**
   * Check if excess message is shown
   */
  isExcessMessage(): boolean {
    return this.excessMessageCount !== undefined && this.excessMessageCount > 0;
  }

  /**
   * Check if strategy is MLO
   */
  isMLO(): boolean {
    return this.toast.strategy === Strategy.MLO;
  }

  /**
   * Check if strategy is FTO
   */
  isFTO(): boolean {
    return this.toast.strategy === Strategy.FTO;
  }

  /**
   * Check if strategy is OTA
   */
  isOTA(): boolean {
    return this.toast.strategy === Strategy.OTA;
  }

  /**
   * Check if strategy is OCO
   */
  isOCO(): boolean {
    return this.toast.strategy === Strategy.OCO;
  }

  /**
   * Close toast
   */
  close(): void {
    this.onClose.emit(this.toast);
  }

  getMLOPrice(price: number): number {
    return Math.abs(price);
  }

  getColourHighlight(action: string): string {
    if (this.toast.isRejected && (action === 'SELL' || action === 'BUY')) {
      return 'td-wb-notification-toast__text-grey';
    } else if (action === 'SOLD') {
      return 'td-wb-notification-toast__text-red';
    }
  }
}
